<template>
	<div id="index">
		<v-header v-on:islogin='islogin'></v-header>
		<router-view></router-view>
		<v-footer></v-footer>
		<v-login v-on:guanbi='guanbi' v-on:bindSuccess='bindSuccess' v-if="login"></v-login>
	</div>
</template>

<script>
	import vHeader from '@/components/common/header'
	import vFooter from '@/components/common/footer'
	import vLogin from '@/components/common/login'

	export default {
		data() {
			return {
				current: 1,
				login:0,
			};
		},
		methods:{
			islogin:function(islogin){
				this.login = islogin
			},
			guanbi:function(guanbi){
				this.login = guanbi
			},
			bindSuccess:function(guanbi){
				this.login = guanbi
			}
		},
		components: {vHeader,vFooter,vLogin,}
	}
</script>

<style scoped="scoped" lang="scss">
#index{
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue